import { accordionInit } from "../lib/accordion.js";

document.addEventListener("DOMContentLoaded", () => {
    console.log("[support-page.js inited]");

    accordionInit();
});
